
import { useState, useEffect } from 'react';

/**
 * Hook to manage the admin page loading state
 */
export const useAdminLoading = (
  attendeesLoading: boolean,
  activityLoading: boolean,
  isChangingMode: boolean,
  connectionStatus: 'connected' | 'disconnected' | 'connecting'
) => {
  const [isLoading, setIsLoading] = useState(true);
  
  // Update overall loading state with debounce
  useEffect(() => {
    if (!attendeesLoading && !activityLoading && !isChangingMode && connectionStatus !== 'connecting') {
      // Small delay to avoid flickering during quick loading states
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setIsLoading(true);
    }
  }, [attendeesLoading, activityLoading, isChangingMode, connectionStatus]);
  
  return { isLoading };
};
